export default "__VITE_ASSET__BUTn3m2i__";